export const getPriority = state => state.priority;
